import AreaPage from "@/components/AreaPage";

const area = {
  name: "MG Road",
  slug: "water-tank-cleaning-mg-road-gurugram",
  h1: "Water Tank Cleaning near MG Road, Gurugram",
  description: "Water tank cleaning near MG Road Gurugram. Commercial buildings, offices, and residences. Same-day service available.",
  content1: "MG Road (Mehrauli-Gurgaon Road) is Gurugram's original commercial spine, lined with offices, shopping complexes, hotels, and mixed-use buildings. TankBuddy provides both commercial and residential water tank cleaning for properties along and around MG Road. From corporate office tanks requiring compliance certificates to residential apartments in nearby sectors, we handle it all.",
  content2: "The high commercial density along MG Road means many buildings have large-capacity tanks (10,000-50,000 litres) that require industrial-grade cleaning equipment. TankBuddy's commercial team operates high-capacity pumps and 200+ bar jet systems specifically for these large installations. We offer flexible scheduling — nights and weekends available to minimize business disruption. AMC plans available for regular maintenance.",
  nearby: [
    { href: "/water-tank-cleaning-dlf-phase-gurugram", label: "DLF Phase 1-5" },
    { href: "/water-tank-cleaning-sushant-lok-gurugram", label: "Sushant Lok" },
    { href: "/water-tank-cleaning-udyog-vihar-gurugram", label: "Udyog Vihar" },
    { href: "/water-tank-cleaning-palam-vihar-gurugram", label: "Palam Vihar" },
  ],
};

export default function MGRoadPage() {
  return <AreaPage area={area} />;
}
